import { ButtonGroup } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { useIsTechnicianCoordinator } from 'shared/permissions/useIsTechnicianCoordinator';
import { useIsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { purchaseRequestService } from '../api/purchase-request.service';
import { LinkButton } from 'components/ui';
import { PurchaseLineColumns } from '../purchase-request';

export const PurchaseRequestList = () => {
  const translationPrefix = 'pages.purchase-requests.list';
  const [numPurchaseAutomatic, setNumPurchaseAutomatic] = useState(0);

  const canCreate = useIsTechnicianCoordinator() || useIsTenantAdministrator() || useIsTechnician();

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = PurchaseLineColumns();

  useEffect(() => {
    purchaseRequestService
      .getAllPaginated(0, 0, { automatic_generated: true, status: 'NEW' })
      .then((res) => {
        setNumPurchaseAutomatic(res.count);
      });
  }, []);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      pageType="purchase_requests"
      menuRight={
        <ButtonGroup>
          {canCreate && <LinkButton prefix={translationPrefix} to="new" label="add" />}
          <LinkButton
            requirePermission={'tenantAdmin'}
            prefix={translationPrefix}
            to="automatic"
            label="automatic"
            count={numPurchaseAutomatic}
          />
        </ButtonGroup>
      }>
      <EnhancedDataGrid
        columns={columns}
        service={purchaseRequestService}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
};

export default PurchaseRequestList;
